import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';

import { AppComponent } from './app.component';
import { routes } from './app.routes';
import { MessageService } from 'primeng/api';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { ToastService } from '@shared/services';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'; // ✅ add this
import { TokenRetrievalInterceptor } from './core/interceptors/token-retrieval.interceptor';
import { TokenService } from './core/services/token.service';
import { RefreshTokenInterceptor } from './core/interceptors/refresh-token.interceptor';
import { ToastModule } from 'primeng/toast';
import { ConfirmationToastComponent } from './entities/components/confirmation-toast/confirmation-toast.component';
import { LoaderInterceptor } from './core/interceptors/loader.interceptor';
import { ErrorHandlerInterceptor } from './core/interceptors/error-handler.interceptor';
import { SpinnerComponent } from './shared/components/spinner/spinner.component';

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    RouterModule.forRoot(routes),
    TranslateModule.forRoot(),
    BrowserAnimationsModule,
    ToastModule,
    ConfirmationToastComponent,
    SpinnerComponent,
  ],
  providers: [
    provideHttpClient(
      withInterceptors([
        RefreshTokenInterceptor,
        TokenRetrievalInterceptor,
        LoaderInterceptor,
        ErrorHandlerInterceptor,
      ]),
    ),
    MessageService,
    TranslateService,
    ToastService,
    TokenService,
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
